import { useRef, useState } from "react";

import { TInputTag } from "components/InputMultipleTag";

import { queryGetUserClientList } from "@type/api/user";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

interface UseGetClientListProps {
  enabled?: boolean;
}

const payload = {
  pageSize: 50,
  sort: {
    key: "full_name",
    type: "asc",
  },
};

export const useGetClientList = ({ enabled }: UseGetClientListProps) => {
  const procesedPage = useRef<number[]>([]);
  const [page, setPage] = useState(1);
  const [clientOptions, setClientOptions] = useState<TInputTag[]>([]);

  const { isLoading } = useQueryWithCallbacks({
    queryKey: queryGetUserClientList._key({
      page: page,
      ...payload,
    }),
    enabled: enabled && page > 0,
    queryFn: () => queryGetUserClientList({ page: page, ...payload }),
    onSuccess: (res) => {
      if (!procesedPage.current.includes(res.page)) {
        setClientOptions((prev) => {
          const newData: TInputTag[] = res.data.map((client) => ({
            id: client.idUnique,
            name: client.fullName,
          }));

          if (res.page === 1) {
            return newData;
          }

          return [...prev, ...newData];
        });

        if (res.page * res.pageSize < res.total) {
          setPage(res.page + 1);
        }
        procesedPage.current = [...procesedPage.current, res.page];
      }
    },
  });

  return {
    isLoadingClientOptions: isLoading,
    clientOptions,
  };
};
